import './index.css'
import Button from '../button'
import TagGradient from '../tag-gradient';
import { useState } from 'react';

function HomepageHero(){
    const navigateToLoginPage = () => {
        window.location.href = '/signup';
    }

    const navigateToPricing = () => {
        document.getElementById("pricing-holder").scrollIntoView({
            behavior: 'smooth', // Defines the scrolling behavior
            block: 'start', // Aligns the element at the start of the scrollable area (can be 'start', 'center', 'end', or 'nearest')
            inline: 'nearest' // Aligns the element horizontally (can be 'start', 'center', 'end', or 'nearest')
        });
        
    }

    return (
        <div className='homepage-abovefold-holder'>
        <TagGradient text='Meet your inspiration engine' />
        <h1 className='big-text homepage-title'>Stop chasing conversations.<br></br>
        <span className='highlight-green'>Lead them.</span></h1>
        <p className='small-text description-of-service'>Mako watches the web so you don’t have to — surfacing what’s moving in your space so you can focus on judgment, timing and how you show up.</p>
        <div className='cta-bar'>
        <Button addedFunction={navigateToLoginPage} text='Start 14 day free trial'></Button>
        <Button text='Pricing' addedFunction={navigateToPricing}></Button>
        </div>

        </div>
)
}

export default HomepageHero